import { useCookies } from "react-cookie";
import { useNavigate } from "react-router-dom";
import { letUserLogin } from "../../api/user/login";
import { ROUTES } from "../../config/nav";
import { useAppDispatch } from "../../redux";
import { removeUserData } from "../../redux/UserStore/userstore";
import { postSomethingToRN } from "../../tools";
import CookieMonster, { KnownCookieNames } from "../../tools/CookieMonster";
import { LoginObj } from "../../types/user";
import { resetChecklistStore } from "../../redux/checklistStoreAPI";

export const useAppCookies = (deps: KnownCookieNames[]) =>
  useCookies<KnownCookieNames>(deps);

export const useClearCache = () => {
  const dispatch = useAppDispatch();
  return () => {
    dispatch(removeUserData());
    dispatch(resetChecklistStore());
  };
};

export const useLogin = () => {
  return async (obj?: LoginObj) => {
    const {
      data: { access_token, ...rest },
    } = await letUserLogin(obj);
    const cookie = new CookieMonster();
    let tobeSaved = {
      jwt: access_token,
      idUser: rest.data.user_id,
      email: rest.data.user_email,
      deptRole: rest.data.dept?.role ?? undefined,
      roleId: rest.data?.role_id ?? undefined,
      deptId: rest.data.dept?.dept_id ?? undefined,
      username: rest.data.user_id,
    };

    postSomethingToRN("login");

    cookie.saveAllThisCookies(tobeSaved);
    return rest;
  };
};

export const useLogout = () => {
  const navigate = useNavigate();
  const clearCache = useClearCache();
  return () => {
    const cookie = new CookieMonster();
    clearCache();
    cookie.removeAllthisCookies([
      "jwt",
      "username",
      "idUser",
      "deptRole",
      "email",
      "deptId",
      "roleId",
    ]);
    postSomethingToRN("logout");
    navigate(ROUTES.loginpage);
  };
};
